import { computed, Injectable, signal } from "@angular/core";
import { DOMAIN_FOLDER } from "../constants";
import { DomainFolder } from "../enums";

@Injectable({
  providedIn: "root",
})
export class FolderService {
  private _folder = signal<string | null>(null);

  public folder = computed(() => this._folder());

  constructor() {
    this.ensurefolder();
  }

  ensurefolder() {
    const folder = this.chosseDomainfolder();

    this._folder.set(folder);
  }

  chosseDomainfolder(): DomainFolder {
    const hostname = window.location.host;

    const item = DOMAIN_FOLDER.find((item) => hostname.includes(item.key));

    return item?.folder || DomainFolder.DEFAULT;
  }
}
